jQuery(function($) {
    $('.open-popup-link').click(function (e) {
        e.preventDefault();
        var href = $(this).attr('href').replace('#', '.');
        $.magnificPopup.open({
            items: {
                src: href,
                type: 'inline'
            }
        });
    });

    $('.open-popup-link-iframe').click(function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        if (href.substr(-4) == '.pdf' || href.substr(-4) == '.xls' || href.substr(-5) == '.xlsx' || href.substr(-4) == '.doc' || href.substr(-5) == '.docx') {
            href = 'https://docs.google.com/gview?url=' + href + '&embedded=true';
        }
        $.magnificPopup.open({
            items: {
                src: href,
                type: 'iframe'
            }
        });
    });
});
